// The single curated currency list for the whole dashboard.
// Adding a currency is a one-line change here — do not re-introduce local lists.
export const CURRENCIES = ["EGP", "USD", "EUR", "RUB", "GBP", "AED", "SAR", "CHF"];

/**
 * Option list for a controlled currency <select>.
 *
 * TournamentFee.Currency has no server-side validation and PaymentAccountDialog
 * lets admins type free text, so a row can hold a code outside CURRENCIES. A
 * controlled <select> whose value has no matching <option> renders blank and
 * silently rewrites the stored value on save, so the stored value is appended as
 * a fallback option.
 *
 * The comparison is an exact string match on purpose: that is exactly how a
 * <select> matches its value, so "egp" needs its own option even though "EGP"
 * is in the list.
 */
export function currencyOptions(current?: string | null): string[] {
  const value = (current ?? "").trim();
  if (!value || CURRENCIES.indexOf(value) !== -1) return CURRENCIES;
  return CURRENCIES.concat(value);
}
